import Vue from 'vue';
import './tooltip.component.scss';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class TooltipComponent extends Vue {
  @Prop() idLabelEllipsis!: string;
  @Prop() labelEllipsis!: string | number;
  @Prop() customClass!: string;
  private isShowTooltip = false;
  /**
   * コンテンツの幅が要素の幅よりも長い場合にツールチップを表示する
   */
  showTooltip(): void {
    const elementLabel = document.getElementById(this.idLabelEllipsis);
    if (elementLabel) {
      this.isShowTooltip =
        elementLabel.clientWidth < elementLabel.scrollWidth || elementLabel.clientHeight < elementLabel.scrollHeight;
    }
  }

  render() {
    return (
      <div v-frag>
        <span
          class={this.customClass}
          id={this.idLabelEllipsis}
          onMouseover={this.showTooltip}
          onTouchstart={this.showTooltip}
        >
          {this.labelEllipsis}
        </span>
        {this.isShowTooltip ? (
          <b-tooltip target={this.idLabelEllipsis} custom-class="tooltip-custom" variant="gray1" placement="top">
            {this.labelEllipsis}
          </b-tooltip>
        ) : null}
      </div>
    );
  }
}
